// Sessão anônima para analytics. Sem cookies, sem PII.
// Gera/lê um UUID v4 em localStorage com TTL rolling de 30 dias.

const KEY = "apg_sid";
const TS_KEY = "apg_sid_ts";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

function uuidv4(): string {
  // RFC4122 v4 simples sem dependência externa
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function safeStorage(): Storage | null {
  try {
    if (typeof window === "undefined") return null;
    const t = "__apg_t__";
    window.localStorage.setItem(t, "1");
    window.localStorage.removeItem(t);
    return window.localStorage;
  } catch {
    try {
      return window.sessionStorage;
    } catch {
      return null;
    }
  }
}

let memoryFallback: string | null = null;

export function getSessionId(): string {
  const store = safeStorage();
  const now = Date.now();
  if (!store) {
    if (!memoryFallback) memoryFallback = uuidv4();
    return memoryFallback;
  }
  try {
    const existing = store.getItem(KEY);
    const ts = parseInt(store.getItem(TS_KEY) || "0", 10);
    if (existing && ts && now - ts < TTL_MS) {
      // refresh rolling timestamp
      store.setItem(TS_KEY, String(now));
      return existing;
    }
  } catch {
    /* ignore */
  }
  const fresh = uuidv4();
  try {
    store.setItem(KEY, fresh);
    store.setItem(TS_KEY, String(now));
  } catch {
    /* ignore */
  }
  return fresh;
}

export function getDevice(): "mobile" | "desktop" {
  if (typeof window === "undefined") return "desktop";
  try {
    return window.matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop";
  } catch {
    return "desktop";
  }
}

export interface UtmInfo {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export function getUtm(): UtmInfo {
  if (typeof window === "undefined") return {};
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get("utm_source") || undefined,
      utm_medium: p.get("utm_medium") || undefined,
      utm_campaign: p.get("utm_campaign") || undefined,
    };
  } catch {
    return {};
  }
}
